import { Switch, Field, Label } from "@headlessui/react";
import { XIcon, CheckIcon } from "@phosphor-icons/react";
import clsx from "clsx";

export default function ToggleSwitch({
	enabled,
	setEnabled,
	label,
	displayLabel = true,
}: {
	enabled: boolean;
	setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
	label: string;
	displayLabel?: boolean;
}) {
	return (
		<Field className="bizF-flex bizF-items-center bizF-justify-between">
			{displayLabel && (
				<Label as="span" className="bizF-text-sm hover:bizF-cursor-pointer">
					{label.length > 0 ? (
						<span className="bizF-font-medium bizF-text-gray-900">{label}</span>
					) : (
						<span className="bizF-text-[0.9rem] bizF-text-gray-500">
							I understand this has no impact on my credit score and agree to the{" "}
							<a
								className="bizF-text-[--bizF-theme-color] bizF-font-semibold"
								href="/privacy-policy"
								target="_blank"
							>
								terms & conditions
							</a>
							.
						</span>
					)}
				</Label>
			)}
			<Switch
				checked={enabled}
				onChange={setEnabled}
				className={clsx(
					enabled ? "" : "bizF-bg-gray-200",
					`bizF-relative bizF-inline-flex bizF-h-6 bizF-w-11 bizF-flex-shrink-0 bizF-cursor-pointer bizF-rounded-full bizF-border-2 bizF-border-[--bizF-theme-color] bizF-transition-colors bizF-duration-200 bizF-ease-in-out focus:bizF-outline-none focus:bizF-ring-2 focus:bizF-ring-offset-2`
				)}
				style={
					{
						backgroundColor: enabled ? "var(--bizF-theme-color)" : "",
						"--tw-ring-color": "var(--bizF-theme-color)",
					} as React.CSSProperties
				}
			>
				<span className="bizF-sr-only">I agree to the terms and conditions</span>
				<span
					className={clsx(
						enabled ? "bizF-translate-x-5" : "bizF-translate-x-0",
						"bizF-pointer-events-none bizF-relative bizF-inline-block bizF-h-5 bizF-w-5 bizF-transform bizF-rounded-full bizF-bg-white bizF-shadow bizF-ring-0 bizF-transition bizF-duration-200 bizF-ease-in-out"
					)}
				>
					<span
						className={clsx(
							enabled
								? "bizF-opacity-0 bizF-duration-100 bizF-ease-out"
								: "bizF-opacity-100 bizF-duration-200 bizF-ease-in",
							"bizF-absolute bizF-inset-0 bizF-flex bizF-h-full bizF-w-full bizF-items-center bizF-justify-center bizF-transition-opacity"
						)}
						aria-hidden="true"
					>
						<XIcon
							className="bizF-h-3 bizF-w-3 bizF-stroke-[--bizF-theme-color] bizF-stroke-[10%]"
							size={32}
						/>
					</span>
					<span
						className={clsx(
							enabled
								? "bizF-opacity-100 bizF-duration-200 bizF-ease-in"
								: "bizF-opacity-0 bizF-duration-100 bizF-ease-out",
							"bizF-absolute bizF-inset-0 bizF-flex bizF-h-full bizF-w-full bizF-items-center bizF-justify-center bizF-transition-opacity"
						)}
						aria-hidden="true"
					>
						<CheckIcon
							className="bizF-h-3 bizF-w-3 bizF-stroke-[--bizF-theme-color] bizF-stroke-[10%]"
							size={32}
						/>
					</span>
				</span>
			</Switch>
		</Field>
	);
}
